import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ScrollBox, ShadowBox, ContainerBox } from './ScrollArea.styles';

class ScrollArea extends Component {
  static propTypes = {
    /** Content that displays inside scroll area */
    children: PropTypes.node.isRequired,
    /** px value max height of scrolling container */
    maxHeight: PropTypes.number,
    /** ScrollArea styles */
    theme: PropTypes.oneOf(['default', 'border']),
    /** Color of the shadow - based on the background of your scroll area */
    shadowColor: PropTypes.oneOf(['default', 'grey']),
    /** event to fire when area is scrolled */
    onScroll: PropTypes.func,
    /** Ref function passed to the ScrollBox container for scroll control */
    nodeRef: PropTypes.func
  };

  static defaultProps = {
    maxHeight: 330,
    theme: 'default',
    shadowColor: 'default',
    onScroll: () => {},
    nodeRef: () => {}
  };

  render() {
    const { children, maxHeight, theme, shadowColor, onScroll, nodeRef } = this.props;
    return (
      <ContainerBox>
        <ScrollBox ref={nodeRef} maxHeight={maxHeight} theme={theme} onScroll={onScroll} data-cy="scroll-area">
          {children}
        </ScrollBox>
        {theme === 'default' && (
          <>
            <ShadowBox shadowColor={shadowColor} shadowPosition="top" />
            <ShadowBox shadowColor={shadowColor} />
          </>
        )}
      </ContainerBox>
    );
  }
}

export default ScrollArea;
